module.exports = __webpack_public_path__ + "img/usedHighlight.d067c916.png";